import { create } from "apisauce";
// const baseURL = "https://dockerizedapp.azurewebsites.net/"
const baseURL = "http://192.168.18.46:92";

const apiClient = create({
  baseURL: baseURL,
});

apiClient.addRequestTransform((request) => {
  const username = "admin@example.com";
  const password = "aszx1234";
  request.auth = {
    username,
    password,
  };
  // request.headers.authorization = "Token " + base64Credentials
});

export default apiClient;
